import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { Calendar } from "react-multi-date-picker"; // Import MultiDatePicker
// import "react-multi-date-picker/styles/colors/red.css"
import Pagination from '../../component/Admin/Pagination';

import { formatDate, formatDate01 } from "../../helper/helper";
import { FaEdit, FaSearch, FaTrashAlt, FaMapMarkerAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import { formatLokasiList, adminTable } from '../../component/Admin/adminTable';
const Status = ({ data }) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);

    const [listStatus, setListStatus] = useState([]);



    const header = {
        withCredentials: true
    };

    const weekDays = [
        ["sun", "Min"], //[["name","shortName"], ... ]
        ["mon", "Sen"],
        ["tue", "Sel"],
        ["wed", "Rab"],
        ["thu", "Kam"],
        ["fri", "Jum"],
        ["sat", "Sab"],
    ]
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDates, setSelectedDates] = useState([]); // State untuk menyimpan tanggal yang dipilih
    const [uploadedImage, setUploadedImage] = useState(null); // State untuk menyimpan gambar yang diunggah
    const [disabledDates, setDisabledDates] = useState([]); // State to store disabled dates
    const [jumlahIzin, setJumlahIzin] = useState(0); // State untuk menyimpan jumlah izin
    const [jumlahCuti, setJumlahCuti] = useState(0); // State untuk menyimpan jumlah cuti
    const [selectedUserLokasi, setSelectedUserLokasi] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        date: "",
        status: "",
        document: ""
    }); // State untuk menyimpan pesan kesalahan

    const handleSearch = useCallback(async (term) => { // Use useCallback for memoization
        if (term) {
            console.log(term);
            const response = await axios.get(`/api/search/${term}`);

            setUsers(response.data);
        } else {
            setUsers([]);
        }
    }, []); // Dependency array

    const handleUserSelect = async (user) => {
        const [absensiResponse, statusResponse, lokasiResponse] = await Promise.all([
            axios.get(`/api/absensi/${user.id_user}/${formatDate01(new Date())}`, header),
            axios.get(`/api/absensi/status/${user.id_user}`, header),
            axios.get(`/api/lokasi/user/${user.id_user}`, { withCredentials: true }),
        ]);

        const dates = absensiResponse.data.map(item => new Date(item.tanggal));
        setDisabledDates(dates);
        setJumlahIzin(statusResponse.data.izin);
        setJumlahCuti(statusResponse.data.cuti);
        setSelectedUserLokasi((lokasiResponse.data || []).map((l) => l.nama));
        setSelectedUser(user);
        setUsers([]);
        setSelectedDates([])
    };

    const handleDateChange = (dates) => {
        const dateStrings = dates.map(date => date.format("YYYY-MM-DD"));
        console.log(dateStrings);
        setSelectedDates(dateStrings);
    };

    const handleMonthChange = async (month) => {
        const allAbsensi = await axios.get(`/api/absensi/${selectedUser.id_user}/${formatDate01(month)}`, header)
        const dates = allAbsensi.data.map(item => new Date(item.tanggal));
        setDisabledDates(dates);
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Mencegah reload halaman

        // Reset pesan kesalahan
        setErrorMessage({
            date: "",
            status: "",
            document: ""
        });

        // Validasi
        if (selectedDates.length === 0) {
            setErrorMessage(prev => ({ ...prev, date: "Tanggal harus dipilih!" }));
            return;
        }
        const statusValue = e.target.status.value; // Ambil nilai status
        if (!statusValue || statusValue === "Pilih Status") { // Periksa apakah status diisi
            setErrorMessage(prev => ({ ...prev, status: "Status harus diisi!" }));
            return;
        }
        if (!uploadedImage) {
            setErrorMessage(prev => ({ ...prev, document: "Dokumen harus dilampirkan!" }));
            return;
        }

        const formData = new FormData(); // Menggunakan FormData untuk mengirim file

        formData.append('user', JSON.stringify(selectedUser)); // Menyimpan data pengguna
        formData.append('status', e.target.status.value); // Menyimpan status
        formData.append('dates', JSON.stringify(selectedDates)); // Menyimpan tanggal yang dipilih

        if (uploadedImage) {
            const blob = await fetch(uploadedImage).then(r => r.blob()); // Mengonversi URL gambar ke Blob
            formData.append('document', blob, 'uploaded_image.png'); // Menyimpan gambar
        }


        await axios.post('/api/absensi/status', formData, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(response => {
            Swal.fire({
                title: `Sukses Set Status`,
                icon: "success",
                html: `
                        <div ><b>Berhasil set status</b> </div>
                        `,
                confirmButtonText: `Tutup`,
                confirmButtonColor: "#883333",
            }).then(response => {

                window.location.reload();
            })
        }).catch(e => {
            console.log(e);
        })



    };

    const isDateDisabled = (date) => {
        const dateObj = new Date(date); // Pastikan date adalah objek Date
        const isDisabled = disabledDates.some(
            (disabledDate) =>
                disabledDate.getFullYear() === dateObj.getFullYear() &&
                disabledDate.getMonth() === dateObj.getMonth() &&
                disabledDate.getDate() === dateObj.getDate()
        );
        return isDisabled;
    };

    useEffect(() => {
        handleSearch(searchTerm);
    }, [searchTerm, handleSearch]); // Add handleSearch to dependencies


    useEffect(() => {
        getListStatus()
    }, []); // Add handleSearch to dependencies





    const selectPage = (value) => {
        setPage(value);
    };

    const nextPage = () => {
        if (page < meta.totalPages) {
            setPage(page + 1);
        }
    };

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const limitPage = (event) => {
        setLimit(Number(event.target.value));
    };












    const closeModal = () => {
        setModalIsOpen(false);
    }


    const handleClick = (user) => {
        try {
            // Extract user ID from object - handle both object and primitive cases
            let userId;
            if (typeof user === 'object' && user !== null) {
                userId = user.id_user;
            } else {
                userId = user;
            }

            if (!userId) {
                console.error('handleClick: userId is undefined', user);
                return;
            }

            // Filter listStatus to find matching items
            const data = listStatus.filter(item => {
                if (!item || !item.id_user) return false;

                // item.id_user is an object with id_user property
                const itemUserId = item.id_user?.id_user;

                if (!itemUserId) return false;

                // Compare as numbers to avoid type mismatch
                return Number(itemUserId) === Number(userId);
            });

            console.log('handleClick - Found data:', data.length, 'items');

            if (data && data.length > 0) {
                setModalData(data);
                setModalIsOpen(true);
            } else {
                console.warn('handleClick: No matching data found for userId:', userId);
                setModalData(null);
                setModalIsOpen(false);
            }
        } catch (error) {
            console.error('handleClick error:', error);
        }
    };






    const openAddModal = () => {
        setModalData({
            username: "",
            password: "",
            nama: "",
            email: "",
            id_devisi: 0
        }); // Reset modal data for new entry
        setModalIsOpen(true); // Open modal
    };

    const getListStatus = () => {
        // setLoadingSmall(true)
        axios.get(`api/izin?page=${page}&limit=${limit}`, {
            withCredentials: true
        })
            .then((response) => {
                setMeta(response.data.meta);
                setListStatus(response.data.items);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };





    return (

        <>
            <div className="flex flex-col  ">
                <div className="flex-1 flex flex-wrap">
                    <div className="flex-1  w-full md:w-1/2">
                        <div className=" mt-4 mx-4 bg-white p-4 rounded-lg">
                            <div className="relative max-w-md w-full">
                                <div className="absolute top-1 left-2 inline-flex items-center p-2">
                                    <FaSearch />
                                </div>
                                <input
                                    id="search"
                                    className="bg-[#d2e4f6] w-full h-10 pl-10 pr-4 py-1 text-base focus-visible:border-none placeholder-gray-500 border rounded-full focus:shadow-outline"
                                    type="search"
                                    placeholder="Cari Pegawai..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {users?.length > 0 && (
                                    <ul className="absolute w-full text-left shadow-lg px-2 z-10 bg-white border rounded-md mt-1">
                                        {users?.map((user) => (
                                            <li
                                                key={user.id_user}
                                                className="p-2 hover:bg-gray-50 hover:underline text-sm border-b text-gray-600 hover:text-gray-800 cursor-pointer flex justify-between"
                                                onClick={() => handleUserSelect(user)}
                                            >
                                                <span>{user.nama}</span>
                                                <small className="text-gray-500 text-xs">{user.id_devisi.nama_divisi}</small>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        {selectedUser && (
                            <div className="mt-4 w-full md:grid md:grid-cols-3 ">
                                <div className=" col-span-2 p-4 w-full">
                                    <div className=" bg-white shadow rounded-lg p-6 w-full">
                                        <h2 className="text-gray-500 text-lg font-semibold pb-1">Data Pegawai</h2>
                                        <div className="my-1"></div>
                                        <div className="bg-gradient-to-r from-red-700 to-gray-500 h-px mb-4"></div>
                                        <div className="chart-container">
                                            {selectedUser ? (
                                                <div>
                                                    {/* <h3>{selectedUser.nama}</h3>
                                            <p>ID: {selectedUser.id_user}</p> */}
                                                    <div className=" w-full mx-auto  ">
                                                        <div className=" shadow-md  rounded-lg">

                                                            <div className="mx-auto right-0 mt-2 ">
                                                                <div className="bg-white rounded-lg overflow-hidden shadow-lg">
                                                                    <div className="text-center p-6 bg-gray-800 ">
                                                                        <svg aria-hidden="true" role="img" className="h-24 w-24 text-white rounded-full mx-auto" width="32" height="32" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256"><path fill="currentColor" d="M172 120a44 44 0 1 1-44-44a44 44 0 0 1 44 44Zm60 8A104 104 0 1 1 128 24a104.2 104.2 0 0 1 104 104Zm-16 0a88 88 0 1 0-153.8 58.4a81.3 81.3 0 0 1 24.5-23a59.7 59.7 0 0 0 82.6 0a81.3 81.3 0 0 1 24.5 23A87.6 87.6 0 0 0 216 128Z"></path></svg>
                                                                        <p className="pt-2 text-lg font-semibold text-gray-50">{selectedUser.nama}</p>
                                                                        <p className="text-sm text-gray-100">{selectedUser.email}</p>
                                                                        <div className="mt-5 space-y-2">
                                                                            <div
                                                                                className="border rounded-full py-2 px-4 text-xs font-semibold text-gray-100"
                                                                            >
                                                                                {selectedUser.id_devisi.nama_divisi}
                                                                            </div>
                                                                            <div className="text-xs text-gray-200 flex items-center justify-center gap-1">
                                                                                <FaMapMarkerAlt />
                                                                                {formatLokasiList(selectedUserLokasi)}
                                                                            </div>
                                                                        </div>
                                                                        <div className="border-b flex justify-around">
                                                                            <div  >
                                                                                <div className="px-4 py-2 hover:bg-gray-100 flex">

                                                                                    <div className="pl-3">
                                                                                        <p className="text-sm font-medium text-white leading-none">
                                                                                            Jumlah Izin /tahun
                                                                                        </p>
                                                                                        <p className="text-xs text-white">{jumlahIzin}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div  >
                                                                                <div className="px-4 py-2 hover:bg-gray-100 flex">

                                                                                    <div className="pl-3">
                                                                                        <p className="text-sm font-medium text-white leading-none">Jumlah cuti /tahun</p>
                                                                                        <p className="text-xs text-white">{jumlahCuti}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                        </div>
                                                        <form className=" border-t border-gray-600 mt-4" onSubmit={handleSubmit}>
                                                            <label className="flex   font-semibold text-gray-800 mt-4 uppercase"><p>Set Status<sup className="text-lg text-red-500 top-0"> *</sup></p></label>

                                                            <select name="status" className="block w-full p-3  text-gray-700 bg-gray-100 appearance-none focus:outline-none focus:bg-gray-200 focus:shadow-inner" required="">

                                                                <option >Pilih Status </option>
                                                                <option value="izin">Izin</option>
                                                                <option value="cuti">Cuti</option>
                                                            </select>
                                                            {errorMessage.status && (
                                                                <div className="text-red-500 text-xs text-left mb-2 mt-1">{errorMessage.status}</div>
                                                            )}

                                                            <div className=" flex justify-center items-center">
                                                                {uploadedImage && ( // Tampilkan gambar jika ada
                                                                    <img src={uploadedImage} alt="Uploaded" className="mt-4 w-1/4 h-auto rounded" />
                                                                )}
                                                            </div>
                                                            <label className="flex   font-semibold text-gray-800 mt-4 uppercase"><p>Dokumen Lampiran Izin/Cuti<sup className="text-lg text-red-500 top-0"> *</sup></p></label>
                                                            <input id="dokumen" type="file" name="dokumen" className="block w-full p-3  text-gray-700 bg-gray-100 appearance-none focus:outline-none focus:bg-gray-200 focus:shadow-inner" required="" onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file && file.type.startsWith("image/")) {
                                                                    const reader = new FileReader();
                                                                    reader.onloadend = () => {
                                                                        setUploadedImage(reader.result); // Simpan URL gambar
                                                                    };
                                                                    reader.readAsDataURL(file);
                                                                }
                                                            }} />
                                                            {errorMessage.document && (
                                                                <div className="text-red-500 text-xs text-left mb-2 mt-2">{errorMessage.document}</div>
                                                            )}
                                                            <button type="submit" className="w-full py-3 mt-6 font-medium tracking-widest text-white uppercase bg-black shadow-lg focus:outline-none hover:bg-gray-900 hover:shadow-none">Simpan</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div id="dataPegawai"></div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div id="kalender" className="   w-full h-full p-4  ">
                                    <div className=" mx-auto bg-white shadow rounded-lg p-6 h-full w-full">

                                        <h2 className="text-gray-500 text-lg font-semibold pb-1">Set Tanggal Izin/Cuti</h2>
                                        <div className="my-1"></div>
                                        <div className="bg-gradient-to-r from-red-700 to-gray-500 h-px mb-4"></div>
                                        {errorMessage.date && (
                                            <div className="text-red-900 bg-red-200 my-2 text-sm p-2">  {errorMessage.date}</div>
                                        )}
                                        <div className=" w-full " >
                                            <Calendar
                                                weekDays={weekDays}
                                                className="mx-auto w-full red  rounded-md"
                                                onChange={handleDateChange} // Event handler
                                                value={selectedDates.map(date => new Date(date))}
                                                open={true}
                                                mapDays={({ date }) => {
                                                    let props = {};
                                                    if (isDateDisabled(date)) {
                                                        props.disabled = true;
                                                    }
                                                    return props;
                                                }}
                                                onMonthChange={handleMonthChange} // Menambahkan event handler untuk bulan berubah
                                            />
                                            <div className=" flex w-full justify-center ">
                                                <div className="py-4 text-left w-full font-light text-sm">
                                                    {selectedDates.map((item, index) => {
                                                        return (
                                                            <li className="w-full bg-[#1B3C33] text-white my-1 py-1 rounded-lg px-2" key={index}>{formatDate(item)}</li>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div >


            <div className="md:container p-2 sm:p-4 mx-auto">
                <div className="mb-3">
                    <button className={`${adminTable.btnPrimary} w-full`} onClick={openAddModal} type="button">RIWAYAT IZIN & CUTI</button>
                </div>

                <div className={adminTable.list}>
                    {listStatus.length > 0 ? (
                        listStatus.map((item, index) => (
                            <div key={index} className={adminTable.listItem}>
                                <div className={adminTable.listTop}>
                                    <div className="min-w-0 flex-1">
                                        <div className={adminTable.listTitle}>{item.id_user.nama}</div>
                                        <div className={adminTable.listSub}>
                                            {item.status} · {item.jumlah_hari} hari · {item.id_user.id_devisi.nama_divisi}
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleClick(item.id_user);
                                        }}
                                        className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`}
                                        title="Edit"
                                    >
                                        <FaEdit />
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={adminTable.listEmpty}>Data Periode Tidak Ditemukan</div>
                    )}
                </div>

                <div className={`${adminTable.card} ${adminTable.desktopOnly}`}>
                    <div className={adminTable.scroll}>
                        <table className={adminTable.table}>
                            <thead className={adminTable.thead}>
                                <tr>
                                    <th className={adminTable.thCenter}>No.</th>
                                    <th className={adminTable.th}>Username</th>
                                    <th className={adminTable.th}>Nama Pegawai</th>
                                    <th className={adminTable.th}>Devisi</th>
                                    <th className={adminTable.th}>Status</th>
                                    <th className={adminTable.th}>Jumlah</th>
                                    <th className={adminTable.th}>Tanggal Buat</th>
                                    <th className={adminTable.thCenter}>Edit</th>
                                    <th className={adminTable.thCenter}>Hapus</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listStatus.length > 0 ? (
                                    listStatus.map((item, index) => (
                                        <tr key={index} className={adminTable.tr}>
                                            <td className={adminTable.tdCenter}>{(page - 1) * limit + index + 1}</td>
                                            <td className={adminTable.td}>{item.id_user.username}</td>
                                            <td className={`${adminTable.td} font-medium`}>{item.id_user.nama}</td>
                                            <td className={adminTable.td}>{item.id_user.id_devisi.nama_divisi}</td>
                                            <td className={`${adminTable.td} uppercase font-semibold`}>{item.status}</td>
                                            <td className={adminTable.td}>{item.jumlah_hari} Hari</td>
                                            <td className={adminTable.td}>{formatDate(item.createAt)}</td>
                                            <td className={adminTable.tdCenter}>
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        handleClick(item.id_user);
                                                    }}
                                                    className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`}
                                                    title="Edit"
                                                >
                                                    <FaEdit />
                                                </button>
                                            </td>
                                            <td className={adminTable.tdCenter}>
                                                <span className={`${adminTable.actionBtn} text-red-400/80`} title="Hapus">
                                                    <FaTrashAlt />
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className={adminTable.empty}>
                                            Data Periode Tidak Ditemukan
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="mt-3">
                    <Pagination
                        currentPage={page}
                        totalPages={meta.totalPages}
                        limitPage={limitPage}
                        selectPage={selectPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                    />
                </div>
            </div>
        </>

    );
};

export default Status;